import styled from 'styled-components';

// Styling
const FlagKeyIdeasCard = styled.div`
  margin-top: 12px;
  margin-bottom: 12px;
`;

const FlagKeyIdeasHeader = styled.div`
  color: var(--color-light-green);
  font-weight: 600;
  margin-bottom: 4px;
`;

const FlagKeyIdea = styled.div`
  &::before {
    content: '•';
    left: 0;
    padding-right: 8px;
    color: white;
    font-size: var(--font-size-500);
  }
`;

// Interfaces
interface IFlagKeyIdeasProps {
  keyIdeas: string[];
}

// Component
const FlagKeyIdeas = ({ keyIdeas = [] }: IFlagKeyIdeasProps) => {
  // Bold first two words if second word not include restricted words
  const boldFirstTwoWordsHandler = (keyIdea: string) => {
    if (!keyIdea) return '';

    const restrictedWords: string[] = ['a', 'to', 'and', 'or', 'is'];
    const splittedWords = keyIdea.split(' ');

    if (splittedWords.length > 1) {
      const firstWord: string = splittedWords[0];
      const secondWord: string = splittedWords[1];
      const remainingWords: string = splittedWords.slice(2).join(' ');

      if (restrictedWords.includes(secondWord.toLowerCase())) {
        return keyIdea;
      } else {
        return (
          <>
            <b>
              {firstWord} {secondWord}
            </b>{' '}
            {remainingWords}
          </>
        );
      }
    } else {
      return keyIdea;
    }
  };

  if (keyIdeas.length === 0) {
    return '';
  }

  return (
    <FlagKeyIdeasCard>
      <FlagKeyIdeasHeader>KEY IDEAS</FlagKeyIdeasHeader>
      {keyIdeas.map((keyIdea, index) =>
        keyIdea ? (
          <FlagKeyIdea key={index}>
            {boldFirstTwoWordsHandler(keyIdea)}
          </FlagKeyIdea>
        ) : (
          ''
        )
      )}
    </FlagKeyIdeasCard>
  );
};

export default FlagKeyIdeas;
